import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import ProvisionOptionsMenu from './ProvisionOptionsMenu'

export default function Options({
  provisionPk,
  isInvalidate,
  isExpired,
  isAndroid,
}: {
  provisionPk: string
  isInvalidate: boolean
  isExpired: boolean
  isAndroid: boolean
}): ReactElement {
  return (
    <Flex sx={{ gap: '1.6rem', alignItems: 'center', justifyContent: 'flex-end' }}>
      <ProvisionOptionsMenu
        provisionPk={provisionPk}
        isInvalidate={isInvalidate}
        isExpired={isExpired}
        isAndroid={isAndroid}
      />
    </Flex>
  )
}
